import { motion } from "framer-motion";
import { HeartHandshake, GraduationCap, Sparkles } from "lucide-react";
import { ChapterHeading, FadeUp, FloralCorner } from "./shared";

const HIGHLIGHTS = [
    { icon: GraduationCap, text: "Especialista em Saúde Mental do Idoso e Terapia Ocupacional" },
    { icon: HeartHandshake, text: "Acompanho de perto os idosos e oriento as famílias com afeto" },
    { icon: Sparkles, text: "Autora do livro “Cuidados que Transformam”" },
];

const AboutSection = () => (
    <section id="sobre" className="relative overflow-hidden py-20 sm:py-28" data-testid="about-section">
        <FloralCorner className="pointer-events-none absolute -left-8 top-10 h-48 w-48 text-lav" />
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
            <FadeUp className="relative order-2 lg:order-1">
                <div className="absolute -left-5 -top-5 h-full w-full rounded-[2rem] border border-lilac/50" aria-hidden="true" />
                <div className="relative overflow-hidden rounded-[2rem] shadow-2xl shadow-plum/15">
                    <img
                        src="/assets/about.png"
                        alt="Mãos de cuidadora segurando com carinho as mãos de uma pessoa idosa"
                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                        data-testid="about-image"
                    />
                </div>
                <motion.div
                    initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
                    whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="absolute -bottom-8 -right-3 sm:-right-8"
                    data-testid="about-portrait-badge"
                >
                    <div className="h-28 w-28 overflow-hidden rounded-full border-4 border-white shadow-xl shadow-plum/25 sm:h-36 sm:w-36">
                        <img src="/assets/portrait.png" alt="Maricleia Araújo, gerontóloga" className="h-full w-full object-cover" />
                    </div>
                    <p className="mt-2 text-center font-serif text-sm italic text-plum">Maricleia Araújo</p>
                </motion.div>
            </FadeUp>

            <div className="order-1 lg:order-2">
                <ChapterHeading number="01" eyebrow="Sobre" title={<>Uma escuta que <span className="italic text-serenity">acolhe</span>, um cuidado que transforma</>} />
                <FadeUp delay={0.15}>
                    <p className="mt-6 text-base leading-relaxed text-ink sm:text-lg">
                        Dedico minha trajetória a um olhar integral sobre o envelhecimento: cada pessoa idosa carrega uma história, e cada história merece ser cuidada com dignidade, ciência e afeto.
                    </p>
                    <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg">
                        Com atuação em <strong className="font-semibold text-plum">Terapia Ocupacional</strong> e <strong className="font-semibold text-plum">Saúde Mental do Idoso</strong>, uno conhecimento técnico e sensibilidade humana para promover autonomia, bem-estar e qualidade de vida — no domicílio, ao lado da família.
                    </p>
                </FadeUp>
                <div className="mt-8 space-y-4">
                    {HIGHLIGHTS.map((h, i) => (
                        <FadeUp key={h.text} delay={0.2 + i * 0.12} className="flex items-start gap-4">
                            <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-lav to-serenitylight/60 text-plum">
                                <h.icon size={19} />
                            </span>
                            <p className="pt-2 text-base font-medium text-plum sm:text-lg">{h.text}</p>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default AboutSection;
